module.exports = __webpack_public_path__ + "static/media/Outline.50a3445b.svg";